module.exports = __webpack_public_path__ + "img/logo.7ad0d9c9.png";